import Container from 'react-bootstrap/Container';
import './FrontProductsBlock.css';
import ProductList from "./ProductList";

function FrontProductsBlock() {
    return (
        <div className="py-4">
            <Container className="mb-4">
                <a href="#" className="text-uppercase text-secondary">Хиты продаж</a>&nbsp;/&nbsp;
                <a href="#" className="text-uppercase text-decoration-underline">Новинки</a>&nbsp;/&nbsp;
                <a href="#" className="text-uppercase text-decoration-underline text-danger">Акции и скидки</a>
            </Container>
            
                <ProductList/>                  
            
        </div>
    );
}

export default FrontProductsBlock;